import React from 'react';
import AiVideo from '../../video/fore.mp4';
import './about.css';

const About = () => {
  return (
    <section className="about-container" id="about">
      <div className="about-inner">
        <div className="about-media">
          <video
            className="about-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            aria-label="Artificial intelligence digital animation"
          >
            <source src={AiVideo} type="video/mp4" />
          </video>
          <div className="about-media-shade" aria-hidden="true" />
          <div className="about-media-label">
            <span>TECHNOLOGY WITH PURPOSE</span>
            <strong>Modern thinking. Practical solutions.</strong>
          </div>
        </div>

        <div className="about-info">
          <span className="about-eyebrow">ABOUT KODEX SOLUTIONS</span>
          <h2>Technology shaped around people, progress and real business needs.</h2>
          <p>
            <strong>Kodex Solutions</strong> is a privately held technology
            consulting firm based in Sweden. With a deep well of cross-industry
            expertise, we are committed to integrating sustainable practices into
            all our development processes. Our business model is centered around
            fostering strong partnerships. Our core services include software
            development, product information management, embedded systems design
            and development, digital solutions, and IT infrastructure. These are
            delivered through our team of expert consultants, dedicated
            development teams, and offshore resources.
          </p>

          <div className="about-pillars" aria-label="Our working principles">
            <div><span>01</span><strong>Business focused</strong></div>
            <div><span>02</span><strong>Reliable delivery</strong></div>
            <div><span>03</span><strong>Long-term partnership</strong></div>
          </div>

          <div className="about-vision">
            <span>OUR VISION</span>
            <p>
              <strong>“Expect a Better Tomorrow”</strong> is the driving force
              behind everything we do—empowering our employees, enhancing
              customer satisfaction, and contributing to a better world.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
